module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC6SURBVHgB3VJtEcIwDE1RUAdUAhLmABytKGAo2ByAA3CwQ8HmAFBQXo8HV0LL7S97d+/S5qtJGpG/h8kpQwgVxBpcUTWCW2PMqH0XmeAdxAG8g/sYyIdOtJUBhxbsQce7jeTZ0daWgms62OT+Qp0k7L8qYfZBvRyodzynlVw5p/cMYqCV6bjJc7AfVTSqBZ+04FULPpsWhm7CEDv5BVYy8EcqcMOBxr4b7V9aJAfhwSVVF/CIRTrL/PAAsc3bX9OUWOUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/eyes-open.png
// module id = bid+
// module chunks = 0